import { baseApi } from '../baseApi';

export interface DashboardStats {
  totals: {
    students: number;
    years: number;
    subjects: number;
    chapters: number;
    videos: number;
    notes: number;
    demoNotes: number;
    paidNotes: number;
    tests: number;
    weekly: number;
    questions: number;
  };
  charts: {
    studentsByYear: { name: string; students: number }[];
    subjectChapters: { name: string; chapters: number }[];
  };
}

export const statsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getDashboardStats: builder.query<{ success: boolean; data: DashboardStats }, void>({
      query: () => '/api/stats/dashboard',
      providesTags: ['Dashboard'],
    }),
  }),
});

export const { useGetDashboardStatsQuery } = statsApi;
